import { get, patch, post, httpDelete } from 'store/http/httpAction';
import { SET_IP_LISTS, SET_IP_DETAIL, RESET_IP_DETAIL, SET_PAGINATION } from './actionType';

const setIpList = ipListsData => ({
  type: SET_IP_LISTS,
  payload: { ipListsData },
});

const setIpDetail = ipDetail => ({
  type: SET_IP_DETAIL,
  payload: { ipDetail },
});

export const resetIpDetail = () => ({
  type: RESET_IP_DETAIL,
});

export const setPagination = paginationData => ({
  type: SET_PAGINATION,
  payload: { paginationData },
});

export const fetchIpList = (pageSize, currentPage) => dispatch => get('/admin/ip_address', { per_page: pageSize, page: currentPage }, dispatch).then((data) => {
  if (_.isArray(data.data)) {
    dispatch(setIpList(data.data));
    if (data.meta && data.meta.pagination) {
      dispatch(setPagination(data.meta.pagination));
    }
  }
});

export const fetchIpDetail = id => dispatch => get(`/admin/ip_address/${id}`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data.data)) {
    dispatch(setIpDetail(data.data));
  }
});

export const addIpAddress = (form, cb) => dispatch => post('/admin/ip_address', { ...form }, dispatch).then((data) => {
  if (data && data.data && _.isFunction(cb)) {
    cb();
  }
});

export const updateIpAddress = (id, form, cb) => dispatch => patch(`/admin/ip_address/${id}`, { ...form }, dispatch).then((data) => {
  if (data && data.data && !_.isEmpty(data.data) && _.isFunction(cb)) {
    cb();
  }
});

export const deleteIpAddress = (id, cb) => dispatch => httpDelete(`/admin/ip_address/${id}`, {}, dispatch).then((data) => {
  if (data.deleted && _.isFunction(cb)) {
    cb();
  }
});



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/flow/action.js